import { Component, HostListener, OnInit,ViewEncapsulation } from '@angular/core';
import { ViewportScroller } from '@angular/common';

import { SharedService } from '../../shared/_services/shared.service';

@Component({
  selector: "app-shared-layout",
  templateUrl: "./shared-layout.component.html",
  styleUrls: ["./shared-layout.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class SharedLayoutComponent implements OnInit {

  @HostListener('window:scroll', ['$event']) onScroll(event: any) {
    if (this.sharedService.isBrowser) {
      let currentYPosition = window.pageYOffset;

      let elem: any = document.getElementById("scrollTopBtn") as HTMLButtonElement;

      if (currentYPosition > 240) {
        elem.style.display = "flex";
      } else {
        elem.style.display = "none";
      }
    }
  }

  constructor(private ViewportScroller: ViewportScroller,
    private sharedService: SharedService) { }

  ngOnInit(): void { }

  scrollToTop() {
    this.ViewportScroller.scrollToPosition([0, 0]);
  }
}